import React, { Component } from 'react';

class HydrationDayProgressPreloader extends Component {
    render() {
        return <div className="hydration-chart placeholder" />;
    }
}

export default HydrationDayProgressPreloader;
